import { ComponentProps } from 'react';
import clsx from 'clsx';

import styles from './Tabs.module.css';

interface TabProps extends ComponentProps<'button'> {
  active?: boolean;
  iconOnly?: boolean;
}

export default function Tab({ active = false, iconOnly = false, className, children, ...props }: TabProps) {
  return (
    <button
      className={clsx(styles.tab, active && styles.active, iconOnly && styles.iconOnly, className)}
      role="tab"
      aria-selected={active}
      type="button"
      {...props}
    >
      {children}
    </button>
  );
}
